module.exports = __webpack_public_path__ + "img/pandas_new.6f73f8ad.jpg";